import React from "react";
import { useSelector, useDispatch } from "react-redux";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/memberVisitsSaga";

export const PeriodType = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.memberVisits.filters.period_days);
  const selectedFilters = useSelector((state) => state.memberVisits.selectedFilters.period_days);

  return (
    <div className="select-box" style={{ width: "150px" }}>
      <p className="offers-title">Period</p>
      <MultiSelectDropdown
        options={options}
        selectedFilters={selectedFilters}
        placeholder="Select Period "
        onSelectChange={(data) =>
          dispatch(actionCreators.updateFilter({ key: "period_days", data }))
        }
      />
    </div>
  );
};
